<template>
  <footer class="ft">
    <div class="ui-container">
      <div class="ft__top">
        <div class="ft__brand">
          <img class="ft__logo" src="/images/pclogo.png" alt="艾斯达 Asstar" />
          <p class="ft__slogan">AIoT 全链路技术服务商</p>
          <p class="ft__desc">
            专注于物联网、人工智能、AR 交互及智能硬件定制，打通「硬件—云端—应用—生态」闭环。
          </p>
        </div>

        <nav class="ft__col" aria-label="产品与服务">
          <h4>产品与服务</h4>
          <router-link to="/products.html">全部产品</router-link>
          <router-link to="/service/aiot.html">AIOT 服务</router-link>
          <router-link to="/service/llm.html">大模型服务</router-link>
        </nav>

        <nav class="ft__col" aria-label="解决方案">
          <h4>解决方案</h4>
          <router-link to="/solutions.html">物联网方案</router-link>
          <router-link to="/solutions.html">AR 交互与可视化</router-link>
          <router-link to="/solutions.html">ITO 服务</router-link>
        </nav>

        <nav class="ft__col" aria-label="技术与支持">
          <h4>技术与支持</h4>
          <router-link to="/tech.html">自研技术底座</router-link>
          <a href="https://upgrader.asstar.com/" target="_blank" rel="noopener noreferrer">固件升级台</a>
          <router-link to="/mall.html">星选商城</router-link>
        </nav>

        <nav class="ft__col" aria-label="关于我们">
          <h4>关于我们</h4>
          <router-link to="/about.html">公司概览</router-link>
          <a href="/helpshow/fb51f6ff-ee96-4992-ba38-a65619b0b3c5" target="_blank" rel="noopener noreferrer">服务协议</a>
          <a href="/helpshow/c2064c1d-082c-4ef1-b56f-68cff69f2030" target="_blank" rel="noopener noreferrer">隐私政策</a>
        </nav>
      </div>
    </div>

    <div class="ft__bar">
      <div class="ui-container ft__bar-inner">
        <p>北京艾斯达科技有限公司</p>
        <p>Asstar Limited</p>
        <p class="ft__links">
          <a href="/helpshow/fb51f6ff-ee96-4992-ba38-a65619b0b3c5" target="_blank" rel="noopener noreferrer">服务协议</a>
          <span class="ft__divider"></span>
          <a href="/helpshow/c2064c1d-082c-4ef1-b56f-68cff69f2030" target="_blank" rel="noopener noreferrer">隐私政策</a>
        </p>
        <p>Copyright © 2019-2025 版权所有</p>
        <p>
          <a href="http://www.beian.miit.gov.cn/publish/query/indexFirst.action" target="_blank" rel="noopener noreferrer">京ICP备19041464号-1</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: "footerel"
  };
</script>

<style scoped>
  .ft {
    margin-top: 0;
    background: #e8382f;
    color: #ffffff;
  }

  .ft__top {
    display: flex;
    justify-content: space-between;
    gap: 32px;
    padding: 52px 0 40px;
  }

  .ft__brand { max-width: 320px; }

  .ft__logo {
    display: block;
    height: 34px;
    width: auto;
    filter: brightness(0) invert(1);
  }

  .ft__slogan {
    margin-top: 14px;
    font-size: 16px;
    font-weight: 600;
  }

  .ft__desc {
    margin-top: 8px;
    font-size: 13px;
    line-height: 1.8;
    color: rgba(255, 255, 255, 0.78);
  }

  .ft__col { display: flex; flex-direction: column; }
  .ft__col h4 {
    margin: 0 0 14px;
    font-size: 14px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.95);
  }
  .ft__col a {
    margin-bottom: 10px;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.72);
    transition: color 0.18s ease;
  }
  .ft__col a:hover { color: #ffffff; }

  /* 版权条：更深的红 */
  .ft__bar {
    background: rgba(0, 0, 0, 0.14);
    padding: 22px 0;
  }

  .ft__bar-inner {
    text-align: center;
    font-size: 13px;
    line-height: 2;
    color: rgba(255, 255, 255, 0.85);
  }

  .ft__bar-inner a { color: rgba(255, 255, 255, 0.85); }
  .ft__bar-inner a:hover { color: #fff; text-decoration: underline; }

  .ft__links {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ft__divider {
    display: inline-block;
    width: 1px;
    height: 12px;
    margin: 0 14px;
    background: rgba(255, 255, 255, 0.4);
  }

  @media (max-width: 1023px) {
    .ft__top {
      flex-wrap: wrap;
      gap: 28px;
      padding: 40px 0 32px;
    }
    .ft__brand { flex: 0 0 100%; max-width: 100%; }
  }

  @media (max-width: 767px) {
    .ft__top { flex-direction: column; gap: 24px; }
    .ft__links { flex-wrap: wrap; }
  }
</style>
